import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JoensuuBaseComponent } from './base/joensuu-base.component';
import { FluentDatasource } from './fluent/fluent-interfaces';
import { FluentWebsocketDatasourceService } from './fluent/fluent-websocket-source';
import { MockFluentVehiclesService } from './fluent/mock-fluent-vehicles.service';

@NgModule({
  declarations: [ JoensuuBaseComponent ],
  imports: [ CommonModule ],
  exports: [ JoensuuBaseComponent ],
  providers: [ {
    provide: FluentDatasource,
    useClass: FluentWebsocketDatasourceService
    //useClass: MockFluentVehiclesService
  }],
})
export class JoensuuModule {

}
